import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class OtpService {
  private apiUrl = `${environment.apiUrl}/otp`;

  constructor(private http: HttpClient) {}

  /**
   * Enviar código OTP al correo del demandado
   * @param correo correo electrónico del demandado
   */
  enviarOtp(correo: string, tramiteId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/enviar`, {correo: correo, tramite: tramiteId });
  }

  /**
   * Verificar código OTP
   * @param correo correo del demandado
   * @param codigo código ingresado por el usuario
   */
  verificarOtp(correo: string, codigo: string): Observable<{ valido: boolean }> {
    return this.http.post<{ valido: boolean }>(`${this.apiUrl}/verificar`, {
      correo,
      codigo
    });
  }
}
